import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Shared page layout for the analysis screens (mosaic + microscope). A pure presentational shell
 * that owns the common frame — a full-height column with an inset (padding/gap) around a top bar
 * and a body row — so both screens share the same layout: top bar across the top, protocol panel
 * on the left, and the remaining space for the screen's main content (mosaics gallery / viewer).
 *
 * - `[layoutTop]` → the shared top bar.
 * - default slot → the body row; each screen projects its own protocol panel first (left) and its
 *   main content after (right). Components are NOT shared here — each screen keeps its own.
 */
@Component({
  selector: 'ts-analysis-layout',
  templateUrl: './analysis-layout.component.html',
  styleUrls: ['./analysis-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnalysisLayoutComponent {}
